import React, { Suspense } from 'react';
import { useOrderContext } from 'contexts/hooks/useOrderContext';
import { useVisibilityContext } from 'contexts/hooks/useVisibilityContext';
import { OrderContext } from 'contexts/OrderContext';
import { VisibilityContext } from 'contexts/VisibilityContext';
import { EntitiesDrawer } from 'components/maps/LayersToolbar';

export const MainMapEntitiesDrawer = ({ entityDrawer }: { entityDrawer?: React.ReactNode }) => {
  const orderContextValue = useOrderContext();
  const visibilityContextValue = useVisibilityContext();
  return (
    <OrderContext.Provider value={orderContextValue}>
      <VisibilityContext.Provider value={visibilityContextValue}>
        <EntitiesDrawer>
          <Suspense fallback={<></>}>{entityDrawer}</Suspense>
        </EntitiesDrawer>
      </VisibilityContext.Provider>
    </OrderContext.Provider>
  );
};
